<template>
  <Form ref="form" @submit.prevent="submit">
    <ZDialog :show="isVisible">
      <template #header>
        <div>
          <h4 class="modal-title">
            Email
          </h4>
        </div>
      </template>
      <template #body>
        <div>
          <ContactSummary class="mb-4" :contact="value" />
          <div class="form-control custom-form">
            <ZSelect v-model="emailType" :value="emailType" label="Email Type" name="emailType"
              :options="lookups['EmailType']" validate="required" />
            <ZInput v-model="emailAddress" :value="emailAddress" name="EmailAddress" label="Email"
              validate="required" />
          </div>
        </div>
      </template>
      <template #footer>
        <div>
          <button type="button" class="btn btn-light" @click="close()">Cancel</button>
          <button type="submit" class="btn btn-primary ms-1" @click="save()">Save</button>
        </div>
      </template>
    </ZDialog>
  </Form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { lookups, contacts } from '@/stores'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZInput from '@/components/utilities/elements/Input.vue'
import ZSelect from '@/components/utilities/elements/Select.vue'
import ContactSummary from '@/components/contacts/forms/contact-summary.vue'
import { Form } from 'vee-validate'
export default {
  name: 'contact-email',
  components: {
    ZDialog,
    ZInput,
    ZSelect,
    ContactSummary,
    Form
  },
  props: {
    value: {
      type: Object
    },
    email: {
      type: Object,
      default() {
        return {
          contact: 0,
          contactEmail: 0,
          emailAddress: '',
          emailType: 0,
          emailTypeName: '',
          primary: ''
        }
      }
    }
  },
  computed: {
    ...mapState(lookups, ['lookups']),
    emailType: {
      get() {
        return this.email !== null ? this.email.emailType : 0
      },
      set(value) {
        this.setItem({
          type: 'Email',
          id: this.email.contactEmail,
          property: 'emailType',
          value: parseInt(value)
        })
      }
    },
    emailAddress: {
      get() {
        return this.email !== null ? this.email.emailAddress : ''
      },
      set(value) {
        this.setItem({
          type: 'Email',
          id: this.email.contactEmail,
          property: 'emailAddress',
          value: value
        })
      }
    },
    isVisible: {
      get() {
        return this.value !== null
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    ...mapActions(contacts, ['setItem', 'removeEmail']),
    close() {
      if (this.email.contactEmail === -1) {
        this.removeEmail(-1)
      }
      this.$emit('closing')
    },
    async save() {
      this.$refs.form.validate().then(async success => {
        if (success.valid) {
          this.$emit('send', this.email.contactEmail)
        }
      })
    },
    submit() { }
  }
}
</script>
<style lang="scss" scoped>
.custom-form {
  text-align: left;
  max-height: 200px;
  height: 200px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
